import { FC, ReactNode } from "react";
import { useUserSettings } from "../../../context/userSettingsContext";
import { useI18n } from "../../../hooks/useTranslations";
import SvgDepartment from "../../icons/Department";
import SvgPercent from "../../icons/Percent";
import Nav from "../Nav";

type SubsidiariesMenuProps = {
  closeSidebar: () => void;
};

const SubsidiariesMenu: FC<SubsidiariesMenuProps> = ({ closeSidebar }) => {
  const i18n = useI18n();
  const userSettings = useUserSettings();

  const subsidiaries: ReactNode[] = [];
  if (userSettings.permissions.subsidiaryVatCodes.read) {
    subsidiaries.push(
      <Nav.Item
        key="/admin/subsidiary_vat_codes"
        text={i18n.t.subsidiaryVatCodes.plural}
        to="/admin/subsidiary_vat_codes"
        icon={SvgPercent}
        onClick={closeSidebar}
      />,
    );
  }

  return (
    <Nav.Item
      key="/admin/subsidiaries"
      text={i18n.t.subsidiaries.plural}
      to={userSettings.permissions.subsidiaries.read ? "/admin/subsidiaries" : undefined}
      icon={SvgDepartment}
      onClick={closeSidebar}
      groupId="menu_subsidiaries"
    >
      {subsidiaries.length ? <Nav.List>{subsidiaries}</Nav.List> : undefined}
    </Nav.Item>
  );
};

export default SubsidiariesMenu;
